import styled from "@emotion/styled"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  VisuallyHidden,
} from "@signal-app/ui"
import range from "lodash/range"
import type { FC } from "react"
import { Localized } from "../../localize/useLocalization"

export interface ColorPickerProps {
  open: boolean
  onSelect: (color: string | null) => void
  onClose: () => void
}

const ColorItem = styled.div`
  height: 2rem;

  &:hover {
    z-index: 2;
    box-shadow: 0 0 0 2px white;
  }
`

const Container = styled.div`
  display: grid;
  padding: 2px;
  grid-template-columns: repeat(8, 2rem);
`

export const ColorPicker: FC<ColorPickerProps> = ({
  open,
  onSelect,
  onClose,
}) => {
  const _onSelect = (color: string | null) => {
    onSelect(color)
    onClose()
  }

  const hues = [-5, 25, 45, 155, 190, 230, 260, 335]
  const saturation = 70
  const luminances = [65, 55, 39]

  const colors = range(0, luminances.length).flatMap((y) =>
    range(0, hues.length).map(
      (x) =>
        `hsl(
          ${hues[x].toFixed()}deg
          ${saturation}%
          ${luminances[y].toFixed()}%
        )`,
    ),
  )

  return (
    <Dialog open={open} onOpenChange={onClose} aria-describedby={undefined}>
      <VisuallyHidden>
        <DialogTitle>
          <Localized name="change-track-color" />
        </DialogTitle>
      </VisuallyHidden>
      <DialogContent>
        <Container>
          {colors.map((color) => (
            <ColorItem
              key={color}
              style={{ backgroundColor: color }}
              onClick={() => _onSelect(color)}
            />
          ))}
        </Container>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => _onSelect(null)}>
          <Localized name="reset" />
        </Button>
        <Button onClick={onClose}>
          <Localized name="close" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}
